function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M233.7 99.4v63.5h-52.8V99.4h52.8m-131.1 0v63.5H49.8V99.4h52.8m144.7-28.5h-80c-8.2 0-14.9 6.7-14.9 14.9v48.8h-21.3V85.8c0-8.2-6.7-14.9-14.9-14.9h-80c-8.2 0-14.9 6.7-14.9 14.9v48.8H0v92.1h28.3v-35.4h99.2v35.4h28.3v-35.4H255v35.4h28.3v-92.1H262V85.8c.2-8.2-6.5-14.9-14.7-14.9z"
})));